(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["article-content-video"] && !Shopify.designMode) return;
  try {
    class ArticleContentVideo extends HTMLElement {
  connectedCallback() {
    this.videoLoaded = false;

    this.videoSrc = this.dataset.videoSrc;
    this.videoUrl = this.dataset.videoUrl;

    this.addEventListener('click', this.handleClick);
  }

  handleClick = () => {
    if (this.videoUrl && typeof lity !== 'undefined') {
      lity(this.videoUrl);
      return;
    }

    if (this.videoSrc) {
      if (!this.videoLoaded) {
        this.loadVideo();
      }

      this.togglePlay();
    }
  };

  loadVideo() {
    const video = document.createElement('video');
    video.src = this.videoSrc;
    video.setAttribute('playsinline', '');
    video.setAttribute('controls', '');
    video.style.width = '100%';

    this.appendChild(video);

    this.video = video;
    this.videoLoaded = true;

    video.addEventListener('ended', this.resetPlayer);
  }

  togglePlay() {
    if (!this.video) return;

    if (this.video.paused) {
      this.video.play();
      this.classList.add('is-playing');
    } else {
      this.video.pause();
      this.classList.remove('is-playing');
    }
  }

  resetPlayer = () => {
    this.classList.remove('is-playing');
  };
}

customElements.define('article-content-video', ArticleContentVideo);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["article-sidebar"] && !Shopify.designMode) return;
  try {
    class ArticleLinks extends HTMLElement {
    constructor() {
      super();

      this.articleContent = document.querySelector('.article-template__content');
      this.list = this.querySelector('ul');
      this.toggleButton = this.querySelector('.article__links__btn');

      if (this.articleContent) {
        this.generateLinks();
      }
      if (this.toggleButton) {
        this.toggleButton.addEventListener('click', (e) => {
          e.stopPropagation();
          this.classList.toggle('active');
        });
      }

      document.addEventListener('click', this.handleOutsideClick.bind(this));
    }

    connectedCallback() {
      window.addEventListener('scroll', () => {
        const sidebar = document.querySelector('.article-sidebar');
        if (!sidebar || window.innerWidth > 990) return;

        const rect = sidebar.getBoundingClientRect();

        if (rect.top <= 160) {
          sidebar.classList.add('is-stuck');
        } else {
          sidebar.classList.remove('is-stuck');
        }
      });
    }


    handleOutsideClick(event) {
      if (!this.contains(event.target) && !event.target.closest('.article__links__btn')) {
        this.classList.remove('active');
      }
    }

    generateLinks() {
      const headings = [];

      const sectionHeadings = this.articleContent.querySelectorAll('h2');
      headings.push(...sectionHeadings);

      if (headings.length) {
        headings.forEach((heading, index) => {
          heading.classList.add(`js-anchor-link-${index}`);
          const li = document.createElement('li');

          if (this.animateContent) {
            li.classList.add('scroll-trigger', 'animate--slide-in');
            li.style.setProperty('--animation-order', index);
          }

          li.innerHTML = `
          <span>${index + 1}.</span>
          <span class="article-link__title">${heading.innerText}</span>
        `;
          li.setAttribute('data-index', index);
          this.list.appendChild(li);

          li.addEventListener('click', (e) => {
            e.stopPropagation();
            const target = document.querySelector(`.js-anchor-link-${index}`);
            if (target) {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
              if (!this.isDesktop) this.classList.remove('active');
            }
          });
        });
      } else {
        this.classList.add('hidden');
        if (this.isDesktop) this.cleanupSticky();
      }
    }
  }

  customElements.define('article-links', ArticleLinks);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["info-block--dimensions"] && !Shopify.designMode) return;
  try {
    class DimensionsTab extends HTMLElement {
  connectedCallback() {
    this.contents = this.querySelectorAll('.info-block__dimensions-content');
    this.selects = this.querySelectorAll('[data-action="width-selector"]');

    this.selects.forEach(select => {
      select.addEventListener('change', (e) => {
        const value = e.target.value;
        this.syncSelects(value, e.target);
        this.show(value);
      });
    });

    this.show(1);
  }

  syncSelects(value, currentSelect) {
    this.selects.forEach(select => {
      if (select !== currentSelect) {
        select.value = value;
      }
    });
  }

  show(index) {
    this.contents.forEach(el => el.classList.remove('is-active'));

    const active = this.querySelector(`.info-block__hk${index}`);
    if (active) {
      active.classList.add('is-active');
    }
  }
}

customElements.define('dimensions-tab', DimensionsTab);
  } catch(e) { console.error(e); }
})();

})();
